import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "px-5 pt-3 pb-2 mb-5" }
const _hoisted_2 = { class: "mb-1" }
const _hoisted_3 = { class: "mt-5" }
const _hoisted_4 = {
  key: 0,
  class: "cardheight flex items-center justify-center card h-auto boxShadow bg-white py-2.5 cursor-pointer"
}
const _hoisted_5 = {
  key: 1,
  class: "mt-2 flex flex-wrap gap-3"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex flex-col justify-between" }
const _hoisted_8 = { class: "flex flex-row justify-between mb-1.5" }
const _hoisted_9 = { class: "items-baseline gap-2 flex flex-row" }
const _hoisted_10 = { class: "text-xs font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_breadCrumbs, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "items-center justify-between flex" }, [
        _createElementVNode("div", { class: "title flex items-center" }, [
          _createElementVNode("h1", null, "Archive Templates")
        ])
      ], -1)),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mt-3" }, [
        _createElementVNode("p", { class: "text-xs" }, " This course helps you to Understand current data protection legislation and underlying principles. It also helps you to Understand what Privacy Awareness is, what PII is, PII Processing, Individual Rights, Cross Border Transfers, PII Breaches, Privacy By Design. This course helps you to understand what Information Security is, awareness on information security, different kinds of security breaches happening in daily life, physical security, email security, Knowing your responsibilities when dealing with Information Security. ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.getArchiveTemplateObj.length==0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "flex items-center justify-center flex-col" }, [
                _createElementVNode("div", { class: "text-sm font-semibold flex justify-center mt-2" }, "No Archive Templates")
              ], -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getArchiveTemplateObj, (obj, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "flex flex-row justify-between cardheight card bg-white boxShadow p-3 cursor-pointer",
                  onClick: ($event: any) => (_ctx.goToTemplateDetails(obj._id))
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["text-sm font-semibold text-wrap h-10 mb-1.5", obj.title.length > 40? 'table-ellipsis':''])
                      }, _toDisplayString(obj.title), 3)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-xs pt-2.5" }, "Activities :", -1)),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(obj.controls.length), 1)
                      ])
                    ])
                  ])
                ], 8, _hoisted_6))
              }), 128))
            ]))
      ])
    ])
  ]))
}